/* src/app/component/navbar/sidebar-toggle-button/sidebar-toggle-button.component.scss */
.toggle-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1001;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 24px;
}
/*# sourceMappingURL=sidebar-toggle-button.component-VRC6CEAU.css.map */
